import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * @description
 * Requires the control to contain something other than whitespaces.
 *
 * @returns An error map with the `blank` property
 * if the validation check fails, otherwise `null`.
 */
export const notBlank: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const isWhitespace = ('' + control.value).trim().length === 0;
  const isValid = !isWhitespace;
  return isValid ? null : { required: true };
};
